var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C777A;}\n\t.st1{fill:#9E9E9E;}\n\t.st2{fill:#707070;}\n\t.st3{fill:#CECECE;}\n\t.st4{fill:#ACC8D5;}\n\t.st5{fill:#9CC3D5;}\n\t.st6{fill:#F8AF23;}\n\t.st7{fill:#3F3679;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.6,189.1h25.1c4.2,0,7.7,3.4,7.7,7.7v28c0,4.2-3.4,7.7-7.7,7.7h-25.1c-4.2,0-7.7-3.4-7.7-7.7v-28 C188.9,192.5,192.3,189.1,196.6,189.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,189.1h25.1c4.2,0,7.7,3.4,7.7,7.7v28c0,4.2-3.4,7.7-7.7,7.7H34.3c-4.2,0-7.7-3.4-7.7-7.7v-28 C26.6,192.5,30,189.1,34.3,189.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.1,224.7v-28c0-4.2,3.4-7.7,7.7-7.7H34.3c-4.2,0-7.7,3.4-7.7,7.7v28c0,4.2,3.4,7.7,7.7,7.7h15.5 C45.5,232.4,42.1,228.9,42.1,224.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.9,224.7v-28c0-4.2-3.4-7.7-7.7-7.7h15.5c4.2,0,7.7,3.4,7.7,7.7v28c0,4.2-3.4,7.7-7.7,7.7h-15.5 C210.5,232.4,213.9,228.9,213.9,224.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.8,79.4c-2-4.9-6.7-8.9-10.6-8.9H64.8c-3.8,0-8.6,4-10.6,8.9l-18.1,44.7h183.8L201.8,79.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.3,70.6H64.8c-3.8,0-8.6,4-10.6,8.9l-18.1,44.7h15.5l18.1-44.7C71.7,74.5,76.4,70.6,80.3,70.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.7,70.6h15.5c3.8,0,8.6,4,10.6,8.9l18.1,44.7h-15.5l-18.1-44.7C184.3,74.5,179.6,70.6,175.7,70.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "219.9,124.2 36.1,124.2 13.8,149.6 242.2,149.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.1,124.2 13.8,149.6 29.3,149.6 51.6,124.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "219.9,124.2 242.2,149.6 226.7,149.6 204.4,124.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 149.6,
    className: "st4",
    width: 228.5,
    height: 54.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 149.6,
    className: "st4",
    width: 15.5,
    height: 54.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 226.7,
    y: 149.6,
    className: "st4",
    width: 15.5,
    height: 54.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.3,176.7c0,3.7-2.6,6.8-5.8,6.8H74.5c-3.2,0-5.8-3-5.8-6.8l0,0c0-3.7,2.6-6.8,5.8-6.8h107.1 C184.7,169.9,187.3,172.9,187.3,176.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.6,167.4h31.7v18.3H38.1C38.1,185.7,27.6,184.4,27.6,167.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.4,167.4h-31.7v18.3h21.2C217.9,185.7,228.4,184.4,228.4,167.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.2,112.8c-2,0-3.5-1.6-3.5-3.5c0-0.5,0.1-0.9,0.3-1.3l9.6-23.7c0.7-1.8,2.8-2.7,4.6-1.9 c1.8,0.7,2.7,2.8,1.9,4.6l0,0l-9.6,23.7C87.9,111.9,86.6,112.8,85.2,112.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.2,116.3c-3.9,0-7.1-3.2-7.1-7.1c0-0.9,0.2-1.8,0.5-2.6l9.6-23.7c1.5-3.6,5.6-5.4,9.2-3.9 c3.6,1.5,5.4,5.6,3.9,9.2l-9.6,23.7C128.7,114.5,126.1,116.3,123.2,116.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.7,112.8c-2,0-3.5-1.6-3.5-3.5c0-0.5,0.1-0.9,0.3-1.3l9.6-23.7c0.7-1.8,2.8-2.7,4.6-1.9s2.7,2.8,1.9,4.6 l0,0l-9.6,23.7C170.5,111.9,169.2,112.8,167.7,112.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 128,
    cy: 54.4,
    r: 41.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.8,54.4c0-20.1,14.3-37.3,34-41C113.1,9.1,91.2,24,87,46.6c-4.3,22.7,10.6,44.5,33.3,48.8 c5.1,1,10.4,1,15.5,0C116,91.7,101.8,74.5,101.8,54.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.5,168.4H74.5c-4,0-7.3,3.7-7.3,8.3s3.3,8.3,7.3,8.3h107.1c4,0,7.3-3.7,7.3-8.3S185.6,168.4,181.5,168.4z  M181.5,181.9H74.5c-2.4,0-4.3-2.4-4.3-5.3s1.9-5.3,4.3-5.3h107.1c2.4,0,4.3,2.4,4.3,5.3S183.9,181.9,181.5,181.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.3,165.9H27.6c-0.8,0-1.5,0.7-1.5,1.5c0,18,11.4,19.7,11.9,19.8c0.1,0,0.1,0,0.2,0h21.2 c0.8,0,1.5-0.7,1.5-1.5v-18.3C60.8,166.6,60.1,165.9,59.3,165.9z M57.8,184.2H38.3c-0.9-0.2-8.6-2-9.2-15.3h28.7V184.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M228.4,165.9h-31.7c-0.8,0-1.5,0.7-1.5,1.5v18.3c0,0.8,0.7,1.5,1.5,1.5h21.2c0.1,0,0.1,0,0.2,0 c0.5-0.1,11.9-1.7,11.9-19.8C229.9,166.6,229.3,165.9,228.4,165.9z M217.7,184.2h-19.5v-15.3h28.7 C226.4,182.3,218.6,184.1,217.7,184.2L217.7,184.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M156,135.4h-12.2c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H156c0.8,0,1.5-0.7,1.5-1.5S156.8,135.4,156,135.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M92.7,175.2H82.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h10.1c0.8,0,1.5-0.7,1.5-1.5S93.5,175.2,92.7,175.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.4,175.2h-10.1c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h10.1c0.8,0,1.5-0.7,1.5-1.5 S174.3,175.2,173.4,175.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M150.3,175.2h-44.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h44.6c0.8,0,1.5-0.7,1.5-1.5 S151.1,175.2,150.3,175.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M113.7,62.9c-1.9,0-3.5,1.5-3.5,3.5c0,0,0,0,0,0c0,0.9,0.4,1.8,1,2.5c0.6,0.7,1.5,1,2.5,1h10.6v8.6 c0,0.9,0.4,1.8,1,2.5c0.7,0.7,1.6,1,2.5,1c0.9,0,1.8-0.4,2.5-1c0.7-0.6,1.1-1.5,1-2.5V70h10.7c0.9,0,1.9-0.4,2.5-1 c0.7-0.6,1.1-1.5,1.1-2.5V54.4c0-0.9-0.4-1.8-1.1-2.5c-0.7-0.7-1.6-1.1-2.5-1h-24.7v-5h24.8c2,0,3.6-1.6,3.6-3.6 c0-0.9-0.4-1.8-1.1-2.5c-0.7-0.7-1.6-1.1-2.5-1h-10.8v-8.6c0-0.9-0.4-1.8-1-2.5c-0.6-0.7-1.5-1-2.4-1c-1.9-0.1-3.5,1.4-3.6,3.3 c0,0.1,0,0.1,0,0.2v8.5h-10.5c-1.9,0-3.5,1.6-3.5,3.5c0,0,0,0,0,0v12.1c0,0.9,0.3,1.8,1,2.5c0.7,0.7,1.6,1,2.5,1h24.7v5L113.7,62.9z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.3,241.9h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S28.2,241.9,27.3,241.9 L27.3,241.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.7,241.9h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S247.5,241.9,246.7,241.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M218.5,241.9h-181c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h181c0.8,0,1.5-0.7,1.5-1.5S219.3,241.9,218.5,241.9z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.2,232.4c0-0.8-0.7-1.5-1.5-1.5h-18.2c1.6-1.7,2.4-3.9,2.4-6.2v-19.4h11.3c0.8,0,1.5-0.7,1.5-1.5v-54.2 c0-0.4-0.1-0.7-0.4-1h0l-22.1-25.2l-18-44.5c-2.2-5.5-7.5-9.8-12-9.8h-22.5c8.1-22.5-3.5-47.3-26-55.4s-47.3,3.5-55.4,26 c-3.4,9.5-3.4,19.9,0,29.4H64.8c-4.5,0-9.7,4.3-12,9.8l-18,44.5l-22.1,25.2h0c-0.2,0.3-0.4,0.6-0.4,1v54.2c0,0.8,0.7,1.5,1.5,1.5 h11.3v19.4c0,2.3,0.9,4.5,2.4,6.2H9.3c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h237.4C247.5,233.9,248.2,233.2,248.2,232.4z  M128,14.1c22.2,0,40.3,18,40.3,40.2c0,22.2-18,40.3-40.2,40.3c-22.2,0-40.3-18-40.3-40.2c0,0,0,0,0,0 C87.8,32.2,105.8,14.2,128,14.1z M55.6,80c1.7-4.3,5.9-7.9,9.2-7.9h23.8c9.7,21.8,35.3,31.6,57.1,21.8c9.7-4.3,17.5-12.1,21.8-21.8 h23.7c3.2,0,7.4,3.6,9.2,7.9l17.3,42.7H38.3L55.6,80z M25.6,138.4h103.7c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-101l8.5-9.7h182.5 l19.7,22.4H17.1L25.6,138.4z M15.3,151.1h225.5v51.2H15.3L15.3,151.1z M68.6,205.3h118.8v19.4c0,2.3,0.9,4.5,2.4,6.2H66.2 c1.6-1.7,2.4-3.9,2.4-6.2L68.6,205.3z M34.3,230.9c-3.4,0-6.2-2.8-6.2-6.2v-19.4h37.5v19.4c0,3.4-2.8,6.2-6.2,6.2L34.3,230.9z  M196.6,230.9c-3.4,0-6.2-2.8-6.2-6.2v-19.4h37.5v19.4c0,3.4-2.8,6.2-6.2,6.2L196.6,230.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoLoan);
export default __webpack_public_path__ + "static/media/autoLoan.1174262c76c7d52298076c45d997cc35.svg";
export { ForwardRef as ReactComponent };